/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useRef } from 'react';
import {
	Box,
	NumberInput as NativeNumberInput,
	ActionIcon,
	Image,
	NumberInputHandlers,
	Text,
	Group,
} from '@mantine/core';
import classes from './NumericInput.module.css';
import ArrowDownIcon from '@assets/icons/arrow-down.svg';
import clsx from 'clsx';

export const getCustomIconStyle = (_size: string) => {
	switch (_size) {
		case 'md':
			return '15px';
		case 'sm':
			return '12px';
		case 'xs':
			return '10px';
		default:
			return undefined;
	}
};

export const NumericInput = (props: {
	error?: string;
	size: string;
	radius?: string;
	placeholder?: string;
	visibleFrom?: string;
	hiddenFrom?: string;
	unit?: string;
	variant?: string;
	label?: string;
	withAsterisk?: boolean;
	defaultValue?: number;
	value?: number;
	max?: number;
	onChange?: any;
	disabled?: boolean;
	allowDecimal?: boolean;
	decimalScale?: number;
	step?: number;
}) => {
	const handlersRef = useRef<NumberInputHandlers>(null);

	const {
		size,
		variant,
		label,
		error,
		hiddenFrom,
		visibleFrom,
		disabled,
		...restProps
	} = props;

	return (
		<Box
			hiddenFrom={hiddenFrom}
			visibleFrom={visibleFrom}
		>
			{label && (
				<Group gap={'5px'}>
					<Text className={classes.label}>{label}</Text>
					{props.withAsterisk && (
						<Text className={classes.asterisk}>*</Text>
					)}
				</Group>
			)}

			<Box
				className={clsx(
					classes.container,
					variant == 'outline' &&
						classes.containerOutline,
					size == 'sm' && classes.containerSm,
					size == 'xs' && classes.containerXs,
					props.error && classes.errorBorder,
					disabled && classes.disabled
				)}
			>
				<NativeNumberInput
					decimalSeparator=","
					max={props.max}
					clampBehavior={
						props.max || props.max == 0
							? 'strict'
							: 'none'
					}
					handlersRef={handlersRef}
					variant="unstyled"
					hideControls
					min={0}
					classNames={{
						input: classes.input,
					}}
					disabled={disabled}
					{...restProps}
				/>
				<Box className={classes.containerControls}>
					{props.unit && (
						<Text
							className={clsx(
								classes.unit,
								size == 'xs' && classes.unitXs,
								size == 'sm' && classes.unitSm
							)}
						>
							{props.unit}
						</Text>
					)}
					<Box
						className={
							classes.containerIncrementDecrement
						}
					>
						<ActionIcon
							disabled={props.disabled}
							size={getCustomIconStyle(size)}
							variant="transparent"
							data-testid="W1FtGXR8_Z5jdHi6B-input"
							onClick={() =>
								handlersRef.current?.increment()
							}
						>
							<Image
								className={classes.containerIconUp}
								src={ArrowDownIcon}
							/>
						</ActionIcon>
						<ActionIcon
							disabled={props.disabled}
							size={getCustomIconStyle(size)}
							variant="transparent"
							data-testid="W2FtGXR8_Z5jdHi6B-input"
							onClick={() =>
								handlersRef.current?.decrement()
							}
						>
							<Image
								src={ArrowDownIcon}
								className={classes.containerIconDown}
							/>
						</ActionIcon>
					</Box>
				</Box>
			</Box>
			{props.error && (
				<Group gap={'5px'}>
					<Text
						size={props.size}
						className={classes.error}
					>
						{props.error}
					</Text>
				</Group>
			)}
		</Box>
	);
};
